/**
 * @Description: 路由配置
 * @Date: 2019-9-25
 * @Modify:
 * @Author: zhangxiaofeng
 */
// const Home = r => require.ensure([], () => r(require('views/budget/home')), 'Home');
/* Layout */
import Layout from '@/components/layout/Index.vue'
import EmptyView from '@/views/EmptyView.vue'
export default [
  {
    path: '/manage',
    component: Layout,
    // redirect: '/manage/home',
    redirect: '/manage/members',
    children: [
      {
        path: 'home',
        component: () => import('@/views/manage/children/Home'),
        meta: { title: '主页', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'members',
        component: () => import('@/views/manage/children/Members'),
        meta: { title: '人员管理', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'deleted', // 已删除人员列表
            component: () => import('@/views/manage/children/children/StaffDeleted'),
            meta: { title: '已删除人员列表', icon: 'home', noCache: true, keepAlive: false, auth: true },
            children: [
              {
                path: ':gldUserId', // 已删除人员 空间文件展示
                component: () => import('@/views/manage/children/children/StaffFiles'),
                meta: { title: '已删除人员空间文件', icon: 'home', noCache: true, keepAlive: false, auth: true }
              }
            ]
          },
          {
            path: 'frozen', // 已冻结账号列表
            component: () => import('@/views/manage/children/children/AccountFrozen'),
            meta: { title: '已冻结账号列表', icon: 'home', noCache: true, keepAlive: false, auth: true }
          }
          // {
          //   path: 'organization', // 跨组织关系列表
          //   component: () => import('@/views/manage/children/children/organization'),
          //   meta: { title: '跨组织管理', icon: 'home', noCache: true, keepAlive: false, auth: true }
          // }
        ]
      },
      {
        path: 'asset',
        component: () => import('@/views/manage/children/asset/index'),
        meta: { title: '资产管理', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'organize',
        component: EmptyView,
        meta: { title: '组织管理', icon: 'home', noCache: true, keepAlive: false, auth: true },
        children: [
          {
            path: 'organization', // 跨组织关系列表
            component: () => import('@/views/manage/children/children/organization'),
            meta: { title: '跨组织管理', icon: 'home', noCache: true, keepAlive: false, auth: true }
          },
          {
            path: 'safe', // 跨组织关系列表
            component: () => import('@/views/manage/children/children/safeSetting'),
            meta: { title: '组织安全设置', icon: 'home', noCache: true, keepAlive: false, auth: true }
          }
        ]
      },
      {
        path: 'applications',
        component: () => import('@/views/manage/children/Applications'),
        meta: { title: '企业数据库管理', icon: 'home', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'records',
        component: () => import('@/views/manage/children/Records'),
        meta: { title: '操作记录', icon: 'home', noCache: true, keepAlive: false, auth: true }
      }
    ]
  }
]
